module.exports = __webpack_public_path__ + "media/images/weather/119_day-b7a341012e97c5fed507d978abbee5a6.png";